import { useState } from 'react';
import { AlertTriangle, Loader2, Phone, CheckCircle } from 'lucide-react';
import { useEmergency } from '../hooks';

export const PanicButton = () => {
  const { alertLoading, lastAlert, triggerPanic, error } = useEmergency();
  const [showConfirm, setShowConfirm] = useState(false);
  const [location, setLocation] = useState('');
  const [description, setDescription] = useState('');

  const handlePanic = async () => {
    try {
      await triggerPanic({
        location: location || undefined,
        details: description || undefined,
      });
      setShowConfirm(false);
      setLocation('');
      setDescription('');
    } catch {
      // Error handled by hook
    }
  };

  if (lastAlert) {
    return (
      <div className="bg-green-50 rounded-xl border border-green-200 p-6">
        <div className="flex items-center gap-3 mb-3">
          <CheckCircle className="w-6 h-6 text-green-600" />
          <h3 className="text-lg font-semibold text-green-800">Alerta registrada</h3>
        </div>
        <p className="text-green-700">{lastAlert.message}</p>
      </div>
    );
  }

  if (showConfirm) {
    return (
      <div className="bg-red-50 rounded-xl border border-red-200 p-6">
        <div className="flex items-center gap-3 mb-4">
          <AlertTriangle className="w-6 h-6 text-red-600" />
          <h3 className="text-lg font-semibold text-red-800">Confirmar Alerta de Emergencia</h3>
        </div>

        {error && (
          <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg text-sm">
            {error}
          </div>
        )}

        <div className="space-y-3 mb-4">
          <div>
            <label className="block text-sm font-medium text-red-700 mb-1">
              Ubicacion (opcional)
            </label>
            <input
              type="text"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              placeholder="Ej: Entrada principal, Estacionamiento..."
              className="w-full px-3 py-2 border border-red-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-red-700 mb-1">
              Descripcion (opcional)
            </label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Describe brevemente la emergencia..."
              className="w-full px-3 py-2 border border-red-200 rounded-lg text-sm resize-none focus:outline-none focus:ring-2 focus:ring-red-500"
              rows={2}
            />
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={() => setShowConfirm(false)}
            className="flex-1 py-3 border border-slate-300 text-slate-700 rounded-lg font-medium hover:bg-slate-50 transition-colors"
          >
            Cancelar
          </button>
          <button
            onClick={handlePanic}
            disabled={alertLoading}
            className="flex-1 flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white py-3 rounded-lg font-bold transition-colors disabled:opacity-50"
          >
            {alertLoading ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              <>
                <Phone className="w-5 h-5" />
                ENVIAR ALERTA
              </>
            )}
          </button>
        </div>
      </div>
    );
  }

  return (
    <button
      onClick={() => setShowConfirm(true)}
      className="w-full bg-red-600 hover:bg-red-700 text-white py-6 rounded-xl font-bold text-xl transition-colors shadow-lg hover:shadow-xl flex items-center justify-center gap-3"
    >
      <AlertTriangle className="w-8 h-8" />
      BOTON DE PANICO
    </button>
  );
};
